import React from 'react'
import { useSelector } from 'react-redux'
import { Container, Card } from 'react-bootstrap'
import * as S from './pdfElements'
import { Icon as RemServIcon } from 'RemServ/icons'
import {
  formatCurrency,
  formatNumber,
  convertPerAnnumToFortnightly,
  IsSpecialEmployer,
} from 'application/helpers'

export const SummarySheet = (props) => {
  const isDownloadingPdf = useSelector(
    (state) => state.downloadPdf.isDownloading
  )
  const IsREMEQ = IsSpecialEmployer('REMEQ')

  //Determine proposal/estimate state. If at proposal and viewing other quotes in est details treat as no proposal exists
  let isAtProposalStage = useSelector(
    (state) =>
      state.proposal &&
      state.proposal.proposal &&
      state.proposal.proposal.isValid &&
      (state.proposal.proposal.cancelledOn === null ||
        state.proposal.proposal.cancelledOn < state.proposal.proposal.updatedOn)
  )
  let proposalQuoteId = useSelector(
    (state) =>
      state.proposal &&
      state.proposal.proposal &&
      state.proposal.proposal.quoteId
  )

  if (isAtProposalStage) {
    let url = window.location.href.indexOf('estimates/')
    if (url !== -1) {
      let estimateId = window.location.href.substring(url + 10)
      if (estimateId !== proposalQuoteId) isAtProposalStage = false
    }
  }
  let fuelCardProviderBP = useSelector(
    (state) => state.opportunity.bpFuelProvider
  )
  let fuelCardProviderCaltex = useSelector(
    (state) => state.opportunity.caltexFuelProvider
  )
  let fuelCardProviderShell = useSelector(
    (state) => state.opportunity.shellFuelProvider
  )

  let isExGST = useSelector(
    (state) =>
      state.user.employer &&
      state.user.employer.employerGRS &&
      state.user.employer.employerGRS.gstExclusiveDeductionsCode &&
      state.user.employer.employerGRS.gstExclusiveDeductionsCode === 'Yes'
  )

  let isTaxShare = useSelector(
    (state) =>
      state.individualEstimate.estimate &&
      state.individualEstimate.estimate.taxShare &&
      state.individualEstimate.estimate.taxShare === 'Yes'
  )

  let totalPackagePerPay = isExGST
    ? isTaxShare
      ? props.novatedLeaseData.proposalEstimate.totalPackagePerPayExGSTTaxShare
      : props.novatedLeaseData.proposalEstimate.totalPackagePerPayExGST
    : props.novatedLeaseData.proposalEstimate.totalPackagePerPayIncGST

  const leaseTerm =
    props.novatedLeaseData.proposalEstimate.leaseTerm % 12 === 0
      ? props.novatedLeaseData.proposalEstimate.leaseTermYears.toString() +
        ' Years'
      : props.novatedLeaseData.proposalEstimate.leaseTerm.toString() + ' Months'

  const annualKmsText =
    formatNumber(props.novatedLeaseData.proposalEstimate.kmPerAnnum) + ' kms'

  const carRepaymentPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.carRepaymentPerAnnumIncGST
  )

  const vehicleType = props.novatedLeaseData.proposalEstimate.vehicle.id
    ? props.novatedLeaseData.proposalEstimate.vehicleType === 'New'
      ? 'New'
      : 'Used'
    : 'n/a'

  const maintenancePerPay = props.novatedLeaseData.proposalEstimate
    .maintenancePerPayIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.maintenancePerAnnumIncGST
      )
    : 0

  const tyresPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.tyresPerAnnumIncGST
  )

  const fuelPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.fuelPerAnnumIncGST
  )

  const electricityPerPay = props.novatedLeaseData.proposalEstimate
    .electricityPerAnnumIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.electricityPerAnnumIncGST
      )
    : 0

  const regoPerPay = props.exGst
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.regoPerAnnumExGST
      )
    : convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.regoPerAnnumIncGST
      )

  const compInsPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.compInsPerAnnumIncGST
  )

  const roadsidePerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.roadsidePerAnnumIncGST
  )
  const otherRunningCostsPerPayIncGST = props.novatedLeaseData.proposalEstimate
    .otherRunningCostsPerAnnumIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.otherRunningCostsPerAnnumIncGST
      )
    : 0

  const nlFeePerPay = props.novatedLeaseData.proposalEstimate
    .nlFeePerAnnumIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.nlFeePerAnnumIncGST
      )
    : 0

  const noOfServices = props.novatedLeaseData.proposalEstimate.noOfServices
  const roadsideTerm =
    props.novatedLeaseData.proposalEstimate.vehicle.roadsideTerm

  let fuelCardTxnFee = 0
  let fuelCardComment

  if (isAtProposalStage) {
    let fuelCardsSelectedCount =
      (fuelCardProviderBP ? 1 : 0) +
      (fuelCardProviderCaltex ? 1 : 0) +
      (fuelCardProviderShell ? 1 : 0)
    switch (fuelCardsSelectedCount) {
      case 1:
        if (fuelCardProviderBP)
          fuelCardComment =
            '* You will be supplied with a BP Fuel Card, which has no fees'
        else if (fuelCardProviderCaltex)
          fuelCardComment =
            '* 	You have chosen to include Ampol Fuel Card which has 27c fee per transaction'
        else if (fuelCardProviderShell)
          fuelCardComment =
            '* You have chosen to include Shell Fuel Card which has no transaction fees'
        break

      case 2:
        if (fuelCardProviderBP & fuelCardProviderCaltex)
          fuelCardComment =
            '* You will be supplied with a BP Fuel Card, which has no fees. In addition you have chosen to include Ampol: 27c fee per transaction'
        else if (fuelCardProviderBP & fuelCardProviderShell)
          fuelCardComment =
            '* You will be supplied with a BP Fuel Card, which has no fees. In addition you have chosen to include Shell: no fees apply'
        else if (fuelCardProviderCaltex & fuelCardProviderShell)
          fuelCardComment =
            '* You have chosen to include Shell Fuel Card which has no transaction fees, and Ampol Fuel Card which has 27c fee per transaction'
        break

      case 3:
        fuelCardComment =
          '* You will be supplied with a BP Fuel Card, which has no fees. In addition you have chosen to include Ampol: 27c fee per transaction; Shell: no fees apply'
    }

    if (fuelCardProviderCaltex) fuelCardTxnFee = 0.27
  } else {
    //Estimate stage
    fuelCardComment =
      '* You can choose which fuel cards to include. No fees apply for BP or Shell. Ampol incurs a 27c fee per transaction.'
    fuelCardTxnFee = 0.27
  }

  //Arranged by Dealer
  const vehicleAccessories =
    props.novatedLeaseData.proposalEstimate.vehicle &&
    props.novatedLeaseData.proposalEstimate.vehicle.vehicleAccessories
  let vehicleAccessoriesTotal = 0
  vehicleAccessories &&
    vehicleAccessories.forEach(
      (item) => (vehicleAccessoriesTotal += item.amount)
    )

  //Arranged by You
  const accessoriesByYou =
    props.novatedLeaseData.proposalEstimate.vehicle &&
    props.novatedLeaseData.proposalEstimate.vehicle.thirdPartyOption &&
    props.novatedLeaseData.proposalEstimate.vehicle.thirdPartyOption
      .thirdPartyOptionLines
  let accessoriesByYouTotal = 0
  accessoriesByYou &&
    accessoriesByYou.forEach(
      (item) => (accessoriesByYouTotal += item.amountIncGST)
    )

  //Arranged by Us
  const aftermarketOrderLines = useSelector(
    (state) =>
      state.individualEstimate.afterMarketAccessories &&
      state.individualEstimate.afterMarketAccessories.aftermarketOrderLines
  )
  let aftermarketTotal = 0
  aftermarketOrderLines &&
    aftermarketOrderLines.forEach(
      (item) => (aftermarketTotal += item.priceIncGST)
    )

  let insurances =
    props.novatedLeaseData.proposalEstimate.leaseProtectionPremium +
    props.novatedLeaseData.proposalEstimate.rpcPremium +
    props.novatedLeaseData.proposalEstimate.extendedWarrantyPremium +
    props.novatedLeaseData.proposalEstimate.gapCoverPremium
  let addOninsuranceDisclaimer = '* Includes your chosen Add-On Insurances:'
  let insurancesIncluded = []
  if (props.novatedLeaseData.proposalEstimate.leaseProtectionPremium > 0)
    insurancesIncluded.push(
      ' Lease Protection Insurance - ' +
        formatCurrency(
          props.novatedLeaseData.proposalEstimate.leaseProtectionPremium
        )
    )
  if (props.novatedLeaseData.proposalEstimate.rpcPremium > 0)
    insurancesIncluded.push(
      ' Guaranteed Buy Back Insurance - ' +
        formatCurrency(props.novatedLeaseData.proposalEstimate.rpcPremium)
    )
  if (props.novatedLeaseData.proposalEstimate.extendedWarrantyPremium > 0)
    insurancesIncluded.push(
      ' Extended Warranty Insurance - ' +
        formatCurrency(
          props.novatedLeaseData.proposalEstimate.extendedWarrantyPremium
        )
    )
  if (props.novatedLeaseData.proposalEstimate.gapCoverPremium > 0)
    insurancesIncluded.push(
      ' Total Loss Assist Insurance - ' +
        formatCurrency(props.novatedLeaseData.proposalEstimate.gapCoverPremium)
    )
  if (insurancesIncluded.length > 0)
    addOninsuranceDisclaimer += insurancesIncluded.join(';')

  let fuelEfficientText = props.novatedLeaseData.proposalEstimate.vehicle.id
    ? props.novatedLeaseData.proposalEstimate.vehicle.fuelConsumption <= 7
      ? 'Yes'
      : 'No'
    : 'n/a'

  let isPrivateSale = props.novatedLeaseData.proposalEstimate.vehicle.vehicleType &&
        props.novatedLeaseData.proposalEstimate.vehicle.vehicleType.toLowerCase().includes('private')

  let vehicleCost = props.novatedLeaseData.proposalEstimate.vehicle.id
    ? props.novatedLeaseData.proposalEstimate.vehicle.basePrice
    : props.novatedLeaseData.proposalEstimate.totalVehicleValueExGST
    
  vehicleCost =
    vehicleCost -
    props.novatedLeaseData.proposalEstimate.vehicle.dealerDiscount +
    props.novatedLeaseData.proposalEstimate.vehicle.procurementFee

    vehicleCost = vehicleCost * (isPrivateSale ? 1 : 1.1) // For private sale no GST

  let totalVehicleCost = props.novatedLeaseData.proposalEstimate.vehicle.id
    ? props.novatedLeaseData.proposalEstimate.vehicle.totalPurchasePrice
    : props.novatedLeaseData.proposalEstimate.driveawayPrice

  const GeneralDetails = ({ props }) => {
    return (
      <>
        <S.SummaryTableHeader>
          <td colSpan={2} style={{ padding: '12px 3px' }}>
            <b>General Details</b>
          </td>
        </S.SummaryTableHeader>
        <tr>
          <td>Novated Leasing Provider Name</td>
          <td>RemServ</td>
        </tr>
        <tr>
          <td>Car Make/Model</td>
          <td>
            {props.novatedLeaseData.proposalEstimate.vehicle.id
              ? props.novatedLeaseData.proposalEstimate.vehicle.make +
                ' ' +
                props.novatedLeaseData.proposalEstimate.vehicle.family
              : 'n/a'}
          </td>
        </tr>
        <tr>
          <td>Vehicle Type</td>
          <td>{vehicleType}</td>
        </tr>
        <tr>
          <td>Fuel Efficient (i.e. less than 7 litres per 100km)</td>
          <td>{fuelEfficientText}</td>
        </tr>
        <tr>
          <td>Annual Estimated Kilometers</td>
          <td>{annualKmsText}</td>
        </tr>
        <tr>
          <td>Lease Type</td>
          <td>{props.novatedLeaseData.proposalEstimate.productId}</td>
        </tr>
        <tr>
          <td>Lease Term</td>
          <td>{leaseTerm}</td>
        </tr>
        <tr>
          <td>Finance Rate</td>
          <td> {props.novatedLeaseData.proposalEstimate.annualRate}%</td>
        </tr>
        <tr>
          <td>Residual Value</td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.leaseResidualAmountIncGST
            )}
          </td>
        </tr>
        <tr>
          <td>FBT Base Value</td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.vehicleFBTValue
            )}
          </td>
        </tr>
        <S.SummaryTableHeader>
          <td colSpan={2} style={{ padding: '12px 3px' }}>
            <b>Purchase Details</b>
          </td>
        </S.SummaryTableHeader>
        <tr>
          <td>Vehicle Cost</td>
          <td>{formatCurrency(vehicleCost)}</td>
        </tr>
        <tr>
          <td>Accessories</td>
          <td>
            {formatCurrency(accessoriesByYouTotal + vehicleAccessoriesTotal)}
          </td>
        </tr>
        <tr>
          <td>Optional Extras</td>
          <td>{formatCurrency(aftermarketTotal)}</td>
        </tr>
        <tr>
          <td>Dealer Delivery Charges</td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.vehicle.deliveryFee
            )}
          </td>
        </tr>
        <tr>
          <td>Stamp Duty</td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.vehicle.stampDuty
            )}
          </td>
        </tr>
        <tr>
          <td>Luxury Car Tax</td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.luxuryCarTax
            )}
          </td>
        </tr>
        <tr>
          <td>
            Initial 12 Months Registration including Compulsory Third Party
            (CTP)
          </td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.vehicle.registrationFee +
                props.novatedLeaseData.proposalEstimate.vehicle.ctp
            )}
          </td>
        </tr>
        <tr>
          <td>
            Initial 12 Months Comprehensive Insurance{' '}
            {props.novatedLeaseData.proposalEstimate.compInsurance === 'No' && (
              <>
                <br />
                <S.InfoSection>
                  * You have indicated you will be organising your own
                  Comprehensive Motor Vehicle Insurance - the initial cost of
                  this premium is to be paid by you.
                </S.InfoSection>
              </>
            )}
          </td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.compInsurancePremium
            )}
          </td>
        </tr>
        <tr>
          <td>Initial Roadside Assistance</td>
          <td>$0</td>
        </tr>
        <tr>
          <td>Duration of Initial Roadside Assistance</td>
          <td>{roadsideTerm !== null ? roadsideTerm + ' months' : ''}</td>
        </tr>
        <tr>
          <td>
            <b>Total Vehicle Costs</b>
          </td>
          <td>{formatCurrency(totalVehicleCost)}</td>
        </tr>
        {!IsREMEQ && 
          <>
            <tr>
              <S.SummarySheetGreyRow style={{ padding: '12px 3px' }}>Upfront GST Savings</S.SummarySheetGreyRow>
              <S.SummarySheetGreyRow>
                {formatCurrency(
                  props.novatedLeaseData.proposalEstimate.gstCreditClaimable
                )}
              </S.SummarySheetGreyRow>
            </tr>        
            <tr>
              <S.SummarySheetGreyRow>
                Supplier Margin
                <S.InfoSection>
                  * Not included by the financier in the 'Total Amount Financed'
                </S.InfoSection>
              </S.SummarySheetGreyRow>
              <S.SummarySheetGreyRow>
                {formatCurrency(props.novatedLeaseData.proposalEstimate.brokerage)}
              </S.SummarySheetGreyRow>
            </tr>
            <tr>
              <S.SummarySheetGreyRow>
                Financier's Establishment Fee
              </S.SummarySheetGreyRow>
              <S.SummarySheetGreyRow>
                {formatCurrency(
                  props.novatedLeaseData.proposalEstimate.financierEstablishmentFee
                )}
              </S.SummarySheetGreyRow>
            </tr>
            <tr>
              <S.SummarySheetGreyRow>
                Other Fees
                {insurances > 0 && (
                  <S.InfoSection>{addOninsuranceDisclaimer}</S.InfoSection>
                )}
              </S.SummarySheetGreyRow>
              <S.SummarySheetGreyRow>
                {formatCurrency(insurances)}
              </S.SummarySheetGreyRow>
            </tr>
          </>
        }
        
        <tr>
          <td>
            <b>Total Amount Financed</b>
            <br />
            <S.InfoSection>
              (Total Vehicle Costs plus Supplier Margin <i>plus</i> Supplier's
              and Financier's Establishment and Other Fees <i>minus</i> Residual
              Value)
            </S.InfoSection>
          </td>
          <td>
            {formatCurrency((
                totalVehicleCost +
                  props.novatedLeaseData.proposalEstimate.brokerage +
                  props.novatedLeaseData.proposalEstimate
                    .financierEstablishmentFee +
                  insurances
              ) -
                props.novatedLeaseData.proposalEstimate
                  .leaseResidualAmountIncGST
            )}
          </td>
        </tr>
      </>
    )
  }

  const RunningCosts = ({ props }) => {
    return (
      <>
        <S.SummaryTableHeader>
          <td colSpan={2} style={{ padding: '12px 3px' }}>
            <b>Fortnightly Running Costs</b>
          </td>
        </S.SummaryTableHeader>
        <tr>
          <td>Novated Leasing Administration Fee</td>
          <td> {formatCurrency(nlFeePerPay)}</td>
        </tr>
        <tr>
          <td>Lease Payment</td>
          <td> {formatCurrency(carRepaymentPerPay)}</td>
        </tr>
        <tr>
          <td>Vehicle Registration Budget </td>
          <td>{formatCurrency(regoPerPay)}</td>
        </tr>
        <tr>
          <td>Vehicle Comprehensive Insurance Budget</td>
          <td>{formatCurrency(compInsPerPay)}</td>
        </tr>
        <tr>
          <td>Vehicle Roadside Assistance Budget</td>
          <td>{formatCurrency(roadsidePerPay)}</td>
        </tr>
        <tr></tr>
        <tr>
          <td>
            <b>Maintenance Budget</b>
          </td>
          <td>{formatCurrency(maintenancePerPay)}</td>
        </tr>
        <tr>
          <td>
            <span className="ml-3">Based on:</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <span className="ml-3">Services During Lease Term</span>
          </td>
          <td>{noOfServices !== null ? noOfServices : ''}</td>
        </tr>
        <tr>
          <td>
            <span className="ml-3">Cost per Service</span>
          </td>
          <td>
            {noOfServices !== null
              ? formatCurrency(
                  ((props.novatedLeaseData.proposalEstimate
                    .maintenancePerAnnumIncGST /
                    12) *
                    props.novatedLeaseData.proposalEstimate.leaseTerm) /
                    noOfServices
                )
              : ''}
          </td>
        </tr>
        <tr>
          <td>
            <b>Tyres Budget</b>
          </td>
          <td>{formatCurrency(tyresPerPay)}</td>
        </tr>
        <tr>
          <td>
            <span className="ml-3">Based on:</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <span className="ml-3">Tyres Replaced During Lease Term</span>
          </td>
          <td>{props.novatedLeaseData.proposalEstimate.noOfTyresBudget}</td>
        </tr>
        <tr>
          <td>
            <span className="ml-3">Cost per Tyre</span>
          </td>
          <td>
            {formatCurrency(
              ((props.novatedLeaseData.proposalEstimate.tyresPerAnnumIncGST /
                12) *
                props.novatedLeaseData.proposalEstimate.leaseTerm) /
                props.novatedLeaseData.proposalEstimate.noOfTyresBudget
            )}
          </td>
        </tr>
        {props.novatedLeaseData &&
          props.novatedLeaseData.proposalEstimate &&
          props.novatedLeaseData.proposalEstimate.fuelPerAnnumIncGST !== 0 && (
            <>
              <tr>
                <td>
                  <b>Fuel Budget</b>
                  <br />
                  <S.InfoSection>{fuelCardComment}</S.InfoSection>
                </td>
                <td>{formatCurrency(fuelPerPay)}</td>
              </tr>
              <tr>
                <td>
                  <span className="ml-3">Based on:</span>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <span className="ml-3">Fuel Tank Size</span>
                </td>
                <td>
                  {props.novatedLeaseData.proposalEstimate.vehicle.id
                    ? props.novatedLeaseData.proposalEstimate.vehicle.fuelTankCapacity.toFixed(
                        1
                      ) + ' litres'
                    : 'n/a'}
                </td>
              </tr>
              <tr>
                <td>
                  <span className="ml-3">Fuel Consumption</span>
                </td>
                <td>
                  {props.novatedLeaseData.proposalEstimate.vehicle.id
                    ? props.novatedLeaseData.proposalEstimate.vehicle.fuelConsumption.toFixed(
                        2
                      ) + ' litres/100km'
                    : 'n/a'}
                </td>
              </tr>
              <tr>
                <td>
                  <span className="ml-3">Fuel Cost</span>
                </td>
                <td>
                  {props.novatedLeaseData.proposalEstimate.fuelPricePerLitre &&
                    props.novatedLeaseData.proposalEstimate.fuelPricePerLitre >
                      0 &&
                    '$' +
                      props.novatedLeaseData.proposalEstimate
                        .fuelPricePerLitre +
                      '/litre'}
                </td>
              </tr>
              <tr>
                <td>
                  <span className="ml-3">Monthly Fuel Card Fee</span>
                </td>
                <td>$0</td>
              </tr>
              <tr>
                <td>
                  <span className="ml-3">Fuel Card Transaction Fee</span>
                </td>
                <td>{formatCurrency(fuelCardTxnFee)}</td>
              </tr>
            </>
          )}

        {electricityPerPay !== 0 && (
          <>
            <tr>
              <td>
                <b>Electricity Budget</b>
                <S.InfoSection>
                  * Electricity budget per fortnight based on ATO Shortcut
                  method of 4.2c/km travelled
                </S.InfoSection>
                <S.InfoSection>* No charge cards are available</S.InfoSection>
              </td>
              <td>{formatCurrency(electricityPerPay)}</td>
            </tr>
            <tr>
              <td>
                <span className="ml-3">Based on:</span>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                <span className="ml-3">Electricity Consumption</span>
              </td>
              <td>
                {props.novatedLeaseData.proposalEstimate.vehicle.id
                  ? props.novatedLeaseData.proposalEstimate.vehicle.kwhper100km.toFixed(
                      1
                    ) + ' kWh/100km'
                  : 'n/a'}
              </td>
            </tr>
            <tr>
              <td>
                <span className="ml-3">Charge Cost</span>
              </td>
              <td>Not Applicable</td>
            </tr>
            <tr>
              <td>
                <span className="ml-3">Monthly Electricity Card Fee</span>
              </td>
              <td>Not Applicable</td>
            </tr>
          </>
        )}
        <tr>
          <td>
            <b>Other Running Costs</b>
          </td>
          <td> {formatCurrency(otherRunningCostsPerPayIncGST)}</td>
        </tr>
        <tr>
          <td>
            <b>Total Fortnightly Running Costs</b>
          </td>
          <td>{formatCurrency(totalPackagePerPay)}</td>
        </tr>
        <S.SummaryTableHeader>
          <td colSpan={2} style={{ padding: '12px 3px' }}>
            <b>Total Employee Payments</b>
          </td>
        </S.SummaryTableHeader>
        <tr>
          <td>Fortnightly Pre Tax Deduction (a)</td>
          <td>
            {' '}
            {formatCurrency(
              convertPerAnnumToFortnightly(
                props.novatedLeaseData.proposalEstimate.spPreTaxDeduction
              ) +
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.fbtPerAnnum
                )
            )}
          </td>
        </tr>
        <tr>
          <td>Fortnightly Post Tax Deduction (b)</td>
          <td>
            {' '}
            {formatCurrency(
              convertPerAnnumToFortnightly(
                props.novatedLeaseData.proposalEstimate.specm
              )
            )}
          </td>
        </tr>
        <tr>
          <td>Fortnightly Tax Benefit (c)</td>
          <td>
            {formatCurrency(
              convertPerAnnumToFortnightly(
                props.novatedLeaseData.proposalEstimate.taxandMedicareSavings
              )
            )}
          </td>
        </tr>
        <tr>
          <td
            style={{ borderBottomWidth: '2px', borderBottomColor: '#003d79' }}
          >
            <b>Total Fortnightly Cost (a) + (b) - (c)</b>
          </td>
          <td
            style={{ borderBottomWidth: '2px', borderBottomColor: '#003d79' }}
          >
            {formatCurrency(
              convertPerAnnumToFortnightly(
                props.novatedLeaseData.proposalEstimate.spPreTaxDeduction
              ) +
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.fbtPerAnnum
                ) +
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.specm
                ) -
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.taxandMedicareSavings
                )
            )}
          </td>
        </tr>
        <S.InfoSection className="ml-2">
          * Total Lease Payments made to the financier over the term of your
          lease:
        </S.InfoSection>
        <tr>
          <td>
            <b>Total Payments over Lease Term (excl Residual Payment)</b>
          </td>

          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.leaseRepayment *
                props.novatedLeaseData.proposalEstimate.leaseTerm
            )}
          </td>
        </tr>

        <tr>
          <td>
            <b>Total Payments over Lease Term (incl Residual Payment)</b>
          </td>
          <td>
            {formatCurrency(
              props.novatedLeaseData.proposalEstimate.leaseRepayment *
                props.novatedLeaseData.proposalEstimate.leaseTerm +
                props.novatedLeaseData.proposalEstimate
                  .leaseResidualAmountIncGST
            )}
          </td>
        </tr>
      </>
    )
  }

  const Disclaimer = ({ pdf }) => {
    return (
      <S.SummaryTableDisclaimer pdf={pdf}>
        <td colSpan={2}>
          <S.DisclaimerDiscoverMore>
            Discover more about Novated Leasing here:{' '}
            <b>https://www.remservlease.com.au/novated-lease</b>
          </S.DisclaimerDiscoverMore>
          <ol>
            <li>
              Actual salary deductions may slightly differ once the novated
              lease is established. To assist with minimising your FBT
              liability, you will be advised of any changes to the above pre-tax
              and post-tax fortnightly deductions.
            </li>
            <li>Based on a two-month deferred lease structure.</li>
            <li>
              Includes the loan amount, term of the loan, repayment frequency,
              interest rate and all fees and charges relating to the Novated
              Lease quotation.
            </li>
            <li>
              This means all financed costs which include the vehicle cost,
              accessories, on-road costs, other applicable taxes, optional
              extras, initial registration/CTP, financier’s fees, insurances and
              membership products (where applicable).
            </li>
            <li>All quoted items include GST, except vehicle registration</li>
          </ol>
          {!IsREMEQ && 
            <div>
            <S.DisclaimerImptInfo>IMPORTANT INFORMATION</S.DisclaimerImptInfo>
            <ul>
              <li>
                <b>
                  {' '}
                  It is mandatory that you salary package with either of the
                  Salary Packaging Administrator (RemServ or SmartSalary under
                  QGP0065-21) prior to entering a Novated Lease Agreement under
                  QGP0066-23.
                </b>{' '}
                A fortnightly salary packaging administration fee is also
                applicable (in addition to the Novated Lease Suppliers fees), for
                more information including a range of information booklets, please
                refer to the Queensland Contracts Directory
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://qgad.govnet.qld.gov.au/arrangement/ae561a4a-fb87-4b92-98c4-c277ef2d36dc?returnToSearchResults=true"
                >
                  {' '}
                  https://qgad.govnet.qld.gov.au/arrangement/ae561a4a-fb87-4b92-98c4-c277ef2d36dc?returnToSearchResults=true.
                </a>
              </li>
              <li>
                The implications of salary packaging a motor vehicle through a
                novated leasing arrangement, including tax savings will depend on
                your individual circumstances. The information in this publication
                has been prepared by RemServ for general information purposes
                only, without taking into consideration any individual
                circumstances. RemServ and the Queensland Government recommend
                that before acting on any information or entering into a novated
                leasing arrangement , you should consider your objectives,
                financial situation and needs, take the appropriate legal,
                financial or other professional advices bases upon your own
                particular circumstances. You should also read the Standard
                Novation Agreement, Salary Packaging Participation Agreement and
                the relevant Queensland Government Salary Packaging and Novated
                Leasing Information Booklets and Fact Forms available via the
                Queensland Government Arrangements Directory.
                <b>
                  {' '}
                  The Queensland Government strongly recommends that you obtain
                  independent financial advice prior to entering into, or changing
                  the terms of, a salary packaging arrangement.
                </b>
              </li>
              <li>
                Novated Leasing Suppliers must disclose all commissions and
                brokerage fees, refer to the Supplier’s quotation for further
                information.
              </li>
            </ul>
          </div>
        }
        </td>
      </S.SummaryTableDisclaimer>       
    )
  }

  return (
    <S.SummarySheet pdf={isDownloadingPdf}>
      {!isDownloadingPdf && (
        <>
          <S.SummaryHeaderBlock>
            {' '}
            
            {global.config.isBrandRS && IsREMEQ && 
              <RemServIcon iconType="remservMainLogo" size={2} />
            }
            {global.config.isBrandRS && !IsREMEQ && 
              <RemServIcon iconType="remservLeaseLogo" size={2} />
            }
            
            <b> &nbsp;&nbsp;&nbsp;QUOTE SUMMARY TABLE</b>
          </S.SummaryHeaderBlock>
          <S.SummaryTable bordered>
            <thead>
              <tr>
                <th align="center">Item</th>
                <th align="center">Quoted Price</th>
              </tr>
            </thead>
            <tbody>
              <GeneralDetails props={props} />
              <RunningCosts props={props} />
              <Disclaimer />
            </tbody>
          </S.SummaryTable>
        </>
      )}

      {isDownloadingPdf && (
        <div className="card-section">
          <Container className="section mt-4" id="cardetailssection">
            <S.StyledCard>
              <S.StyledCardHeader>
                <S.StyledCardHeaderText id="cardetailssection.title">
                  Quote Summary Table
                </S.StyledCardHeaderText>
              </S.StyledCardHeader>
              <Card.Body>
                <table>
                  <GeneralDetails props={props} />
                </table>
              </Card.Body>
            </S.StyledCard>
          </Container>
          <Container className="section mt-4" id="cardetailssection">
            <S.StyledCard>
              <S.StyledCardHeader>
                <S.StyledCardHeaderText id="cardetailssection.title">
                  Quote Summary Table (cont)
                </S.StyledCardHeaderText>
              </S.StyledCardHeader>
              <Card.Body>
                <table>
                  <RunningCosts props={props} />
                </table>
              </Card.Body>
            </S.StyledCard>
          </Container>
          <Container className="section mt-4" id="cardetailssection">
            <S.StyledCard>
              <S.StyledCardHeader>
                <S.StyledCardHeaderText id="cardetailssection.title">
                  Quote Summary Table (cont)
                </S.StyledCardHeaderText>
              </S.StyledCardHeader>
              <Card.Body>
                <table>
                  <Disclaimer pdf={isDownloadingPdf} />
                </table>
              </Card.Body>
            </S.StyledCard>
          </Container>
        </div>
      )}
    </S.SummarySheet>
  )
}
